export default {
    'search.tip': '请输入搜索关键词',
    'search.producttip': '请输入商品名称'
}